module.exports = __webpack_public_path__ + "media/images/icon-location-351870b901810823cc7db9f86f4e54f8.svg";